var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "editCourseInfoForm",
      staticClass: "edit_course_form",
      attrs: { model: _vm.editCourseInfoForm, rules: _vm.editCourseInfoRules }
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "课程名称", prop: "courseName" } },
        [
          _c("el-input", {
            attrs: {
              autocomplete: "off",
              placeholder: "请输入课程名称",
              maxlength: "30"
            },
            model: {
              value: _vm.editCourseInfoForm.courseName,
              callback: function($$v) {
                _vm.$set(
                  _vm.editCourseInfoForm,
                  "courseName",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "editCourseInfoForm.courseName"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "课程简介", prop: "courseIntroduction" } },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              placeholder: "请输入课程简介",
              rows: "3",
              maxlength: "150",
              "show-word-limit": ""
            },
            model: {
              value: _vm.editCourseInfoForm.courseIntroduction,
              callback: function($$v) {
                _vm.$set(_vm.editCourseInfoForm, "courseIntroduction", $$v)
              },
              expression: "editCourseInfoForm.courseIntroduction"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { display: "flex" } }, [
        _c(
          "div",
          { staticStyle: { width: "40%" } },
          [
            _c(
              "el-form-item",
              {
                staticClass: "subject",
                attrs: { label: "专业科目", prop: "subject" }
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "请选择所属科目", disabled: "" },
                    model: {
                      value: _vm.editCourseInfoForm.subject,
                      callback: function($$v) {
                        _vm.$set(_vm.editCourseInfoForm, "subject", $$v)
                      },
                      expression: "editCourseInfoForm.subject"
                    }
                  },
                  [
                    _vm.subjectList.length > 0
                      ? _c(
                          "div",
                          _vm._l(_vm.subjectList, function(item) {
                            return _c(
                              "el-option",
                              {
                                key: item.id,
                                attrs: {
                                  label: item.name,
                                  title: item.name,
                                  value: item.id
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.name) +
                                    "\n            "
                                )
                              ]
                            )
                          }),
                          1
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                staticClass: "classHour",
                attrs: { label: "课时数", prop: "classHour" }
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "请输入课时数",
                    maxlength: "5",
                    oninput: "value=value.replace(/[^\\d]/g,'')"
                  },
                  model: {
                    value: _vm.editCourseInfoForm.classHour,
                    callback: function($$v) {
                      _vm.$set(_vm.editCourseInfoForm, "classHour", $$v)
                    },
                    expression: "editCourseInfoForm.classHour"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.productFlag == 2 ||
        _vm.productFlag == 3 ||
        _vm.productFlag == 4 ||
        _vm.productFlag == 7
          ? _c(
              "div",
              { staticStyle: { width: "40%" } },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "post",
                    attrs: { label: "选择岗位", prop: "post" }
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          multiple: "",
                          placeholder: "请选择岗位",
                          disabled: ""
                        },
                        model: {
                          value: _vm.editCourseInfoForm.post,
                          callback: function($$v) {
                            _vm.$set(_vm.editCourseInfoForm, "post", $$v)
                          },
                          expression: "editCourseInfoForm.post"
                        }
                      },
                      _vm._l(_vm.postList, function(item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "课程封面", prop: "coursePic" } },
        [
          _c(
            "el-upload",
            {
              staticClass: "avatar-uploader",
              attrs: {
                data: _vm.uploadData,
                disabled: _vm.isDisabled,
                action: _vm.uploadSrc,
                headers: _vm.headers,
                accept: ".jpg,.png,.jpeg",
                "show-file-list": false,
                "on-progress": _vm.handleAvatarProgress,
                "on-success": _vm.handleAvatarSuccess,
                "before-upload": _vm.beforeAvatarUpload
              },
              model: {
                value: _vm.pic,
                callback: function($$v) {
                  _vm.pic = $$v
                },
                expression: "pic"
              }
            },
            [
              _vm.pic
                ? _c("img", { staticClass: "avatar", attrs: { src: _vm.pic } })
                : _c("i", { class: _vm.uploadIcon })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.professional == 2
        ? _c("div", { staticClass: "set_catalog_title" }, [
            _c("h2", [_vm._v("平台跳转设置")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.professional == 2
        ? _c("el-form-item", { attrs: { label: "三天下" } }, [
            _c("p", { staticClass: "tips" }, [
              _vm._v(
                "注：该参数的改变，将影响整个课程下配套的“三天下”业务系统发生变化，包括实训、测验、测评等模块。如频繁切换，已经产生的作答数据，可能会丢失、紊乱。"
              )
            ]),
            _vm._v(" "),
            _vm.platformList.length > 0
              ? _c(
                  "ul",
                  { staticClass: "platform_list" },
                  _vm._l(_vm.platformList, function(item) {
                    return _c(
                      "li",
                      { key: item.id },
                      [
                        _c("span", { staticClass: "platform_name" }, [
                          _vm._v(_vm._s(item.platformName) + "：")
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: item.radio,
                              callback: function($$v) {
                                _vm.$set(item, "radio", $$v)
                              },
                              expression: "item.radio"
                            }
                          },
                          _vm._l(item.platformPathList, function(val) {
                            return _c(
                              "el-radio",
                              { key: val.id, attrs: { label: val.id } },
                              [_vm._v(_vm._s(val.tag))]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              : _c("div", { staticClass: "null_box" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/image/sources/table_no_data.png"),
                      alt: "加载失败"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("暂无数据")])
                ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fee6bc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fee6bc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/course/editCourseInfo.vue
// module id = null
// module chunks = 